export class CourtReservation {
    id?: number;
    court_id: number;
    court_num: number;
    date: string;
    reservation_start_time: Date;
    reservation_end_time: Date;
    time: number;
    duration: number;
    player_ids: number[];
    started: boolean = false;
    finished: boolean = false;
    points: number = 0;
    sets: number[] = [-1, -1, -1, -1, -1, -1];
    approved: boolean = false;
    reservation_status?: string;
    admin_approve_start?: boolean;
    end_match_request_pending?: boolean;
    note?: string;
    user_id: number;
    booking_user: string;
    club_id?: number;
    is_private?: boolean;
    courtReservationPlayer?: any[];
    courtReservationPhoneCallPlayer?: any[];
    fixed_series_id?: string | number | null = null;
    reservation_type?: string;
    court?: any;

    constructor(court_id: number, court_num: number, date: string, time: number, player_ids: number[], duration: number, user_id: number, booking_user: string) {
        this.court_id = court_id;
        this.court_num = court_num;
        this.date = date;
        this.time = time;
        this.player_ids = player_ids;
        this.duration = duration;
        this.points = Math.trunc((Math.random() * 300));
        this.reservation_start_time = new Date(date);
        this.reservation_end_time = new Date(date);
        this.user_id=user_id;
        this.booking_user = booking_user;
    }

}
